import styled, { css } from "styled-components";
import { BIG_SCREEN_MEDIA_QUERY_RULE, SM_MEDIA_QUERY_RULE } from "../../config";

export const LeftSection = styled.div`
  /* border: solid 1px yellow; */
  position: relative;
  width: 35vw;
  /* width: var(--window-width); */
  min-height: var(--window-height);
  max-height: var(--window-height);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  @media (${SM_MEDIA_QUERY_RULE}) {
    width: 90vw;
    min-height: 120vh;
    align-items: flex-start;
  }
`;

export const Pagewrapper = styled.div`
  overflow: hidden;
  z-index: 100;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  --window-width: 50vw;
  --window-height: 100vh;
  @media (${SM_MEDIA_QUERY_RULE}) {
    display: flex;
    flex-direction: column;
    overflow: scroll;
  }
`;

export const VerticalSlider = styled.div`
  min-height: var(--window-height);
  max-height: var(--window-height);
  overflow: hidden;
  /* box-shadow: rgba(0, 222, 122, 0.33) 2px 1px 3px,
    rgb(203 255 119 / 40%) 1px 0px 5px, rgba(0, 51, 28, 0.69) 20px 20px 60px,
    hsl(149deg 44% 48% / 46%) -20px -20px 60px; */
  @media (${SM_MEDIA_QUERY_RULE}) {
    width: 95vw;
  }
`;
export const SliderDepth = styled.div`
  min-height: var(var(--window-height) * 2);
  max-height: var(var(--window-height) * 2);
  position: relative;
  bottom: ${({ slideDown }) => (slideDown ? "var(--window-height)" : "0px")};
  transition: bottom 1s;
  @media (${SM_MEDIA_QUERY_RULE}) {
    width: 95vw;
  }
`;

export const DssModal = {
  Background: styled.div`
    position: fixed;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    z-index: 999;
    background-color: rgba(30, 46, 75, 0.42);
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  Wrapper: styled.div`
    --modal-heigth: 70%;
    --modal-width: 70%;
    @media (${SM_MEDIA_QUERY_RULE}) {
      --modal-heigth: 80%;
      --modal-width: 90%;
    }
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    border-radius: 20px 20px 0px 20px;
    background: linear-gradient(
      0.25turn,
      var(--comanage-green-2),
      var(--comanage-green-1)
    );
    max-width: var(--modal-width);
    max-height: var(--modal-heigth);
    min-width: var(--modal-width);
    min-height: var(--modal-heigth);
    position: relative;
    overflow-y: scroll;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    & div:last-child {
      margin-bottom: 10px;
    }
  `,
  Title: styled.h1`
    color: var(--comanage-purple);
    display: flex;
    flex-direction: row;
    cursor: pointer;
    word-wrap: break-word;
    min-width: 90%;
    max-width: 90%;
    &:hover {
          color: var(--comanage-blue-1);
    }
    transition: color 50ms;
  `,
  Row: styled.div`
    --border-setup: solid 1px var(--comanage-purple);
    border-top: var(--border-setup);
    border-left: var(--border-setup);
    border-right: var(--border-setup);
    min-width: 90%;
    max-width: 90%;
    color: var(--comanage-purple);
    padding: 10px;
    display: flex;
    flex-direction: row;
    -webkit-box-pack: justify;
    justify-content: space-between;
    position: relative;
  `,
  Page: styled.span``,
  Content: styled.span`
    max-width: 80%;
  `,
  TitleButton: styled.span`
    --size: 35px;
    background-color: var(--comanage-purple);
    color: var(--comanage-green-1);
    min-width: var(--size);
    min-height: var(--size);
    max-width: var(--size);
    max-height: var(--size);
    border-radius: 100%;
    display: block;
    text-align: center;
    padding-bottom: 3px;
    margin-left: 10px;
    cursor: pointer;
    @media (${SM_MEDIA_QUERY_RULE}) {
      visibility: collapse;
    }
  `,
  CloseButton: styled.div`
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: absolute;
    top: 10px;
    right: 10px;
    --size: 35px;
    background-color: var(--comanage-purple);
    color: var(--comanage-green-1);
    min-width: var(--size);
    min-height: var(--size);
    max-width: var(--size);
    max-height: var(--size);
    border-radius: 100%;
    display: block;
    text-align: center;
    /* padding-bottom: 3px; */
    margin-left: 10px;
    text-align: center;
    line-height: 33px;
    font-size: 1.6em;
    margin-left: 10px;
    cursor: pointer;
  `,
  FileName: styled.span`
  word-wrap: break-word;
  max-width: 80%;
  `
};
